<template lang="pug">
div(v-if="processosCadastrados")
  div
    app-modal-dashboard.z-index(v-if="cardModalOpen", :modalType="cardModalType", :titulo="modalTitle", :width="1000", @closeCardModal="closeCardModal")
        template(slot="body")
          div(v-if="cardModalType === 'green'")
              conteudo-modal-processos-cadastrados
          div(v-if="cardModalType === 'yellow'")
              conteudo-modal-processos-arquivados
          div(v-if="cardModalType === 'blue'")
              conteudo-modal-processos-em-analise
          div(v-if="cardModalType === 'red'")
              conteudo-modal-processos-finalizados

  .dashboard-info
    .dashboard-info-cards
      .cardTotais
        app-card-dashboard(
          :clickable="processosCadastrados.quantidade && processosCadastrados.quantidade > 0 ? true : false",
          :title="processosCadastrados.label || '-'",
          :content="processosCadastrados.quantidade || 0",
          cardType="green",
          @click.native="processosCadastrados.quantidade && processosCadastrados.quantidade > 0 ? openCardModal('green') : ''"
        )
      .cardTotais
        app-card-dashboard(
          :clickable="processosArquivados.quantidade && processosArquivados.quantidade > 0 ? true : false",
          :title="processosArquivados.label || '-'",
          :content="processosArquivados.quantidade || 0",
          cardType="yellow",
          @click.native="processosArquivados.quantidade && processosArquivados.quantidade > 0 ? openCardModal('yellow') : ''"
        )
      .cardTotais
        app-card-dashboard(
          :clickable="processosEmAnalise.quantidade && processosEmAnalise.quantidade > 0 ? true : false",
          :title="processosEmAnalise.label || '-'",
          :content="processosEmAnalise.quantidade || 0",
          cardType="blue",
          @click.native="processosEmAnalise.quantidade && processosEmAnalise.quantidade > 0 ? openCardModal('blue') : ''"
        )
      .cardTotais
        app-card-dashboard(
          :clickable="processosTitulados.quantidade && processosTitulados.quantidade > 0 ? true : false",
          :title="processosTitulados.label || '-'",
          :content="processosTitulados.quantidade || 0",
          cardType="red",
        )
          template(v-slot:title="")
            div.infoTitulados
              el-tooltip(
                effect='dark',
                placement="top"
              )
                i.el-icon-info.icon-info
                template(slot="content")  Total de títulos são considerados processos digitais e processos físicos que foram titulados pelo ITERPA.

    .dashboard-info-graficos
      .card-graficos
        el-radio-group(v-model="tipoGraficoSelecionado")
          el-radio-button(label="MUNICIPIO") Município
          el-radio-button(label="PROCESSO") Mensal
        grafico-quantidade-processo-municipio(:dadosLabels="processosByMunicipio", v-if="tipoGraficoSelecionado === 'MUNICIPIO'")
        grafico-quantidade-processo-mensal(:dadosLabels="dadosProcessosMensal", v-if="tipoGraficoSelecionado === 'PROCESSO'")

</template>

<script>
import { mapActions } from 'vuex'
import AppCardDashboard from '@/screens/relatorios/components/gerais/AppCardDashboard.vue'
import AppModalDashboard from '@/screens/relatorios/components/gerais/AppModalDashboard.vue'
import ConteudoModalProcessosCadastrados from './ConteudoModalProcessosCadastrados.vue'
import GraficoQuantidadeProcessoMensal from './graficos/GraficoQuantidadeProcessoMensal'
import GraficoQuantidadeProcessoMunicipio from './graficos/GraficoQuantidadeProcessoMunicipio'
import ConteudoModalProcessosArquivados from './ConteudoModalProcessosArquivados'
import ConteudoModalProcessosEmAnalise from './ConteudoModalTotalProcessosEmAnalise'
import ConteudoModalProcessosFinalizados from './ConteudoModalProcessosFinalizados'

export default {

  components: {
    AppCardDashboard,
    AppModalDashboard,
    ConteudoModalProcessosCadastrados,
    GraficoQuantidadeProcessoMensal,
    GraficoQuantidadeProcessoMunicipio,
    ConteudoModalProcessosArquivados,
    ConteudoModalProcessosEmAnalise,
    ConteudoModalProcessosFinalizados
  },

  data () {
    return {
      processosCount: [],
      processosCadastrados: {},
      processosArquivados: {},
      processosEmAnalise: {},
      processosTitulados: {},

      cardModalOpen: false,

      tipoGraficoSelecionado: 'MUNICIPIO',
      cardModalType: null,
      clickedProcesso: {},

      dadosProcessosMensal: '',
      processosByMunicipio: ''

    }
  },

  async created () {
    await this.loadCards()
    this.processosByMunicipio = await this.getDadosGraficosMunicipio()
    this.dadosProcessosMensal = await this.getDadosGraficosMensal()
  },

  beforeDestroy () {
    this.closeCardModal()
  },

  props: {
    RelatorioService: this.RelatorioService,
    pageSize: {
      type: Number,
      default: 10
    },
    loading: {
      Type: Boolean,
      default: false
    }
  },

  computed: {

    modalTitle () {
      switch (this.cardModalType) {
        case 'green':
          return 'Processos Cadastrados'
        case 'yellow':
          return 'Processos Arquivados'
        case 'blue':
          return 'Processos em Análise'
        case 'red':
          return 'Processos Titulados'
        default:
          return ''
      }
    }
  },
  methods: {
    ...mapActions({
      getProcessosCadastrados: 'processos/getProcessosCadastrados',
      getDadosGraficosMunicipio: 'processos/getProcessosByMunicipio',
      getDadosGraficosMensal: 'processos/getProcessosByMes'
    }),

    async loadCards () {
      this.processosCount = await this.getProcessosCadastrados()
      this.processosCadastrados = this.processosCount.filter(value => value.codigo === 'CADASTRADO')[0]
      this.processosArquivados = this.processosCount.filter(value => value.codigo === 'ARQUIVADO')[0]
      this.processosEmAnalise = this.processosCount.filter(value => value.codigo === 'EM_ANALISE')[0]
      this.processosTitulados = this.processosCount.filter(value => value.codigo === 'TITULADOS')[0]
    },

    openCardModal (cardType) {
      this.cardModalType = cardType
      this.cardModalOpen = true
    },

    closeCardModal (cardType) {
      this.cardModalOpen = false
    },

    /*
     * Função que envia o processo, que veio do componente filho AppListagemProcessosRelatorios,
     * para a tela de relatorios, para ser exibido no modal
     */
    onClickedProcessoListagem (processo) {
      this.$emit('viewProcessosHasClicked', processo)
    }

  }

}

</script>

<style scoped lang="scss">

.limpar {
  margin-right: 20px;
  cursor: pointer;
  &:hover {
    font-weight: bold;
  }
}
.icon {
  margin-right: 7px;
}
.el-select {
  width: 100%;
}
.label {
  margin: 0;
  padding: 12px 0 8px 0px;
}
.button-row {
  margin-top: 10px;
  text-align: right;
}
.right {
  float: right;
  cursor: pointer;
  margin: 10px 0px;
}
.pagination {
    text-align: center;
}
.full-width {
    width: -webkit-fill-available;
}

/* Workaround para modal sobrepor o mapa, necessita revisão*/
.z-index {
  z-index: 4000 !important;
}

/* Cards e gráficos */
.cardTotais:nth-child(-n + 2) {
  margin-bottom: 5%;
}

.cardTotais {
  width: 45%;
  margin-right: 20px;
}

.infoTitulados {
  display: flex;
  justify-content: flex-end;
  padding-left: 25px;
  position: relative;
}

.card-graficos {
  border: 2px solid #34495e;
  border-radius: 12px;
  padding: 5px;
  box-shadow: 0px 3px 6px #00000029;
  text-align: center;
}

.dashboard-info{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.dashboard-info-cards {
  width: 50%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 0 5% 0;
  justify-content: space-between;
}

.dashboard-info-graficos {
  width: 50%;
  padding: 0 0 5% 0;
}

.el-radio-group /deep/ .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
  box-shadow: none;
}

@media only screen and (max-width: 1256px) {
  .dashboard-info {
    flex-direction: column;
  }

  .dashboard-info-cards {
    width: auto;
    padding-right: 0;
  }

  .dashboard-info-graficos {
    width: auto;
  }

  .cardTotais {
    width: 45%;
  }

  .card-graficos {
    margin: 0;
  }

  .cardTotais:nth-child(2n) {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/portal/publico/components/ConsultaRelatorio.vue